import app from './app';
import { USERPROFILE_SERVICE_URL } from '../../libs/constants';


//POST
const getTeamList = (userId, profileDetailsDisplayMode) => async (dispatch, getState, api) => {
    dispatch(setListRefreshed(false));

    await api.post(`${USERPROFILE_SERVICE_URL}uam/list/${userId}`)
        .then(response => {
            if (response.data.hasOwnProperty("teamList")) {
                if (profileDetailsDisplayMode === true) {
                    dispatch({
                        type: "SET_SELECTED_USER_TEAMS",
                        payload: response.data.teamList || []
                    });
                }
                else {
                    dispatch({
                        type: "SET_TEAM_LIST",
                        payload: response.data.teamList || []
                    });
                }
            }
            else {
                if (profileDetailsDisplayMode === true) {
                    dispatch({
                        type: "SET_SELECTED_USER_TEAMS_CALL_COMPLETE",
                        data: true
                    });
                }
                else {
                    dispatch(setAPIFetchError(true));
                    dispatch(setListRefreshed(true));
                }
            }
        })
        .catch(error => {
            if (profileDetailsDisplayMode === true) {
                dispatch({
                    type: "SET_SELECTED_USER_TEAMS_CALL_COMPLETE",
                    data: true
                });
            }
            else {
                dispatch(setAPIFetchError(true));
            }
        });
};

const getTeamListForSpecificUserProfile = (userId, profileDetailsDisplayMode) => async (dispatch, getState, api) => {
    dispatch(setListRefreshed(false));

    const headerConfig = { headers: { "DRS-Fetch-Type": "getTeamsList" } };
    await api.post(`${USERPROFILE_SERVICE_URL}uam/userprofileteamlist/${userId}`, null, headerConfig)
        .then(response => {
            if (response.data.hasOwnProperty("teamList")) {
                if (profileDetailsDisplayMode === true) {
                    dispatch({
                        type: "SET_SELECTED_USER_TEAMS",
                        payload: response.data.teamList || []
                    });
                }
                else {
                    dispatch({
                        type: "SET_TEAM_LIST",
                        payload: response.data.teamList || []
                    });
                }
            }
            else {
                if (profileDetailsDisplayMode === true) {
                    dispatch({
                        type: "SET_SELECTED_USER_TEAMS_CALL_COMPLETE",
                        data: true
                    });
                }
                else {
                    dispatch(setAPIFetchError(true));
                    dispatch(setListRefreshed(true));
                }
            }
        })
        .catch(error => {
            if (profileDetailsDisplayMode === true) {
                dispatch({
                    type: "SET_SELECTED_USER_TEAMS_CALL_COMPLETE",
                    data: true
                });
            }
            else {
                dispatch(setAPIFetchError(true));
            }
        });
};

//POST
const getTeamMembers = (userId, teamId) => async (dispatch, getState, api) => {
    dispatch(setFetchingMembersForTeamId(teamId));

    await api.post(`${USERPROFILE_SERVICE_URL}uam/members/${userId}/${teamId}`)
        .then(response => {
            if (response.data.hasOwnProperty("members")) {
                const responseData = {
                    members: response.data.members || [],
                    teamId: teamId
                }
                dispatch({
                    type: "SET_TEAM_MEMBERS",
                    payload: responseData
                });
            }
            else {
                dispatch(setFetchingMembersForTeamId(null));
            }
        })
        .catch(error => {
            dispatch(setFetchingMembersForTeamId(null));
        });
};

//POST
const createTeam = (userId, requestData) => async (dispatch, getState, api) => {

    dispatch(app.setLoading(true));

    await api.post(`${USERPROFILE_SERVICE_URL}uam/${userId}`, requestData)
        .then(response => {
            if (response.data.teamId) {
                dispatch(getTeamList(userId));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }

            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const inviteMember = (userId, teamId, requestData) => async (dispatch, getState, api) => {

    dispatch(app.setModalSpinner(true));
    dispatch(app.setModalErrorMessageId(null));

    await api.post(`${USERPROFILE_SERVICE_URL}uam/invite/${userId}/${teamId}`, requestData)
        .then(response => {
            dispatch(app.closeAppModal());

            if (response.data.message === "Invitation sent successfully") {
                dispatch(app.setAppModal({ type: "info", messageId: "team_invite_success" }));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            if (error.response.data && error.response.data.message) {
                dispatch(app.setModalSpinner(false));
                dispatch(app.setModalErrorMessageId("UAM." + error.response.data.message));
            }
            else {
                dispatch(app.closeAppModal());
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            }
        });
};

//POST
const acceptInvite = requestData => async (dispatch, getState, api) => {

    dispatch(setAcceptInviteSuccess(false));
    dispatch(setAcceptInviteCallComplete(false));

    const config = {
        headers: {
            'Authorization': 'Bearer guestAcceptTeamInvite'
        }
    }

    await api.post(`${USERPROFILE_SERVICE_URL}uam/accept`, requestData, config)
        .then(response => {
            if (response.data.message === "Invitation accepted successfully") {
                dispatch(setAcceptInviteSuccess(true));
            }

            dispatch(setAcceptInviteCallComplete(true));
        })
        .catch(error => {
            dispatch(setAcceptInviteCallComplete(true));
        });
};

//POST
const deleteTeam = (userId, teamId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(`${USERPROFILE_SERVICE_URL}delete/uam/${teamId}`)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.message === "Team deleted successfully") {
                dispatch(getTeamList(userId)); // refresh teams list
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const deleteMemberFromTeam = requestData => async (dispatch, getState, api) => {
    const { userId, memberId, teamId, exitFromTeam } = requestData;

    dispatch(app.setLoading(true));
    await api.post(`${USERPROFILE_SERVICE_URL}delete/uam/${memberId}/${teamId}`)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.message === "User deleted successfully from provided team") {
                if (exitFromTeam) {
                    dispatch(getTeamList(userId)); // refresh teams list
                }
                else {
                    dispatch(getTeamMembers(userId, teamId)); // refresh members list
                }
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const deleteAllMembersFromTeam = (userId, teamId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(`${USERPROFILE_SERVICE_URL}delete/uam/allmembers/${userId}/${teamId}`)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.message === "All members deleted successfully") {
                dispatch(getTeamMembers(userId, teamId)); // refresh members list
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};
const setListRefreshed = isRefreshed => {
    return {
        type: 'SET_LIST_REFRESHED',
        data: isRefreshed
    }
}

const setAPIFetchError = isError => {
    return {
        type: 'SET_API_FETCH_ERROR',
        data: isError
    }
}

const setAcceptInviteSuccess = isSuccess => {
    return {
        type: 'SET_ACCEPT_INVITE_SUCCESS',
        data: isSuccess
    }
}

const setFetchingMembersForTeamId = teamId => {
    return {
        type: 'SET_FETCHING_MEMBERS_FOR_TEAM_ID',
        data: teamId
    }
}

const setAcceptInviteCallComplete = teamId => {
    return {
        type: 'SET_ACCEPT_INVITE_CALL_COMPLETE',
        data: teamId
    }
}

const uamActions = {
    getTeamList: getTeamList,
    getTeamMembers: getTeamMembers,
    createTeam: createTeam,
    deleteTeam: deleteTeam,
    deleteMemberFromTeam: deleteMemberFromTeam,
    deleteAllMembersFromTeam: deleteAllMembersFromTeam,
    inviteMember: inviteMember,
    setListRefreshed: setListRefreshed,
    setAPIFetchError: setAPIFetchError,
    setFetchingMembersForTeamId: setFetchingMembersForTeamId,
    setAcceptInviteSuccess: setAcceptInviteSuccess,
    acceptInvite: acceptInvite,
    setAcceptInviteCallComplete: setAcceptInviteCallComplete,
    getTeamListForSpecificUserProfile: getTeamListForSpecificUserProfile
}

export default uamActions;